import { MC, waitForEvent, playSound } from "../../../animate/utils";
import { BaseGame } from "./BaseGame";
export default class Game22 extends BaseGame {
    helpBtn: any;
    initGame = async (game: MC, gameEnd: () => void, helpBtn: any) => {
        this.helpBtn = helpBtn;
        game.visible = true;
        game.x = 680;
        game.gotoAndPlay(1);
        game.mouseChildren = false;
        await waitForEvent(game, "questionEnd");
        if (!this.shouldPlay) return;
        helpBtn(false);
        this.addEventToBtn(game, gameEnd, game.bun);
        this.addEventToBtn(game, gameEnd, game.henhouse);
        this.addEventToBtn(game, gameEnd, game.snail);
        game.mouseChildren = true;
    };
    addEventToBtn = (game: MC, gameEnd: () => void, currentBtn: MC) => {
        currentBtn.gotoAndStop(0);
        currentBtn.cursor = "pointer";
        currentBtn.addEventListener("click", async () => {
            currentBtn.gotoAndStop(0);
            currentBtn.gotoAndStop(1);
            await this.checkIfCorrectAnswer(game, gameEnd, currentBtn);
            if (!this.shouldPlay) return;
        });
        currentBtn.addEventListener("rollover", async () => {
            currentBtn.gotoAndStop(1);
        });
        currentBtn.addEventListener("rollout", async () => {
            currentBtn.gotoAndStop(0);
        });
    };
    checkIfCorrectAnswer = async (game: MC, gameEnd: () => void, currentBtn: MC) => {
        if (currentBtn.name === "henhouse") {
            this.helpBtn(true);
            game.gotoAndPlay(102);
            await waitForEvent(game, "gameEnd");
            if (!this.shouldPlay) return;
            gameEnd();
        } else {
            await playSound("wrong");
            if (!this.shouldPlay) return;
        }
    };
}
